export const genders = [
  { key: 'male', value: '남성' },
  { key: 'female', value: '여성' }
];

export const careers = [
  {
    key: 'five',
    value: '0~5년차'
  },
  {
    key: 'ten',
    value: '6~10년차'
  },
  {
    key: 'fifteen',
    value: '11~15년차'
  },
  {
    key: 'twenty',
    value: '16~20년차'
  },
  {
    key: 'gttwenty',
    value: '20년차 이상'
  }
];

export const ages = [
  {
    key: 'teenager',
    value: '10대'
  },
  {
    key: 'twenty',
    value: '20대'
  },
  {
    key: 'thirty',
    value: '30대'
  },
  {
    key: 'forty',
    value: '40대'
  },
  {
    key: 'fifty',
    value: '50대'
  },
  {
    key: 'sixty',
    value: '60대'
  }
];

export const grades = [
  {
    key: 'grade1',
    value: '1학년'
  },
  {
    key: 'grade2',
    value: '2학년'
  },
  {
    key: 'grade3',
    value: '3학년'
  },
  {
    key: 'grade4',
    value: '4학년'
  },
  {
    key: 'grade5',
    value: '5학년'
  },
  {
    key: 'grade6',
    value: '6학년'
  }
];

export const middleGrades = [
  {
    key: 'grade1',
    value: '1학년'
  },
  {
    key: 'grade2',
    value: '2학년'
  },
  {
    key: 'grade3',
    value: '3학년'
  }
];

export const gradeStats = [
  { key: 'grade', value: '학년별', innerKey: grades },
  {
    key: 'gender',
    value: '성별',
    innerKey: genders
  }
];

export const middleGradeStats = [
  { key: 'grade', value: '학년별', innerKey: middleGrades },
  {
    key: 'gender',
    value: '성별',
    innerKey: genders
  }
];

export const stats = [
  {
    key: 'career',
    value: '근속년수',
    innerKey: careers
  },
  {
    key: 'age',
    value: '연령대',
    innerKey: ages
  },
  {
    key: 'gender',
    value: '성비',
    innerKey: genders
  }
];

export const xlsxStats = [
  {
    key: 'career',
    value: '근속별',
    innerKey: careers
  },
  {
    key: 'age',
    value: '연령별',
    innerKey: ages
  },
  {
    key: 'gender',
    value: '성별',
    innerKey: genders
  }
];

export const healthStats = [
  {
    key: 'age',
    value: '연령대',
    innerKey: ages
  },
  {
    key: 'gender',
    value: '성비',
    innerKey: genders
  }
];

export const xlsxHealthStats = [
  {
    key: 'age',
    value: '연령별',
    innerKey: ages
  },
  {
    key: 'gender',
    value: '성별',
    innerKey: genders
  }
];
